var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFavorite = function SvgIconFavorite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.67 18.247a1.01 1.01 0 0 1-1.338-.003l-.565-.504C4.39 13.835 1.5 11.259 1.5 8.099 1.5 5.523 3.557 3.5 6.175 3.5c1.479 0 2.898.677 3.825 1.747A5.13 5.13 0 0 1 13.825 3.5c2.618 0 4.675 2.023 4.675 4.599 0 3.16-2.89 5.736-7.267 9.648z"
  })));
};
export default SvgIconFavorite;